export default "__VITE_ASSET__cl8saj7q__"